import { useLang } from '@/pages/home/context/LanguageContext';

const contentPT = {
  tagline: 'Parceiro técnico estratégico para operações industriais. Especialistas em AVAC, manutenção industrial e serviços para o setor petrolífero.',
  services: 'Serviços',
  serviceItems: ['Manutenção AVAC', 'Climatização Industrial', 'Setor Petrolífero', 'Inspeção Técnica', 'Manutenção Preventiva', 'Assistência Técnica'],
  company: 'Empresa',
  companyItems: [
    { label: 'Sobre Nós', href: '#about' },
    { label: 'Setores', href: '#industries' },
    { label: 'Qualidade', href: '#quality' },
    { label: 'Equipa', href: '#about' },
  ],
  contact: 'Contacto',
  contactLabel: 'Contacto',
  schedule: 'Seg–Sex: 08h–17h',
  rights: 'Todos os direitos reservados.',
  devBy: 'Desenvolvido por',
};

const contentEN = {
  tagline: 'Strategic technical partner for industrial operations. Specialists in HVAC, industrial maintenance and services for the oil sector.',
  services: 'Services',
  serviceItems: ['HVAC Maintenance', 'Industrial Air Conditioning', 'Oil Sector', 'Technical Inspection', 'Preventive Maintenance', 'Technical Assistance'],
  company: 'Company',
  companyItems: [
    { label: 'About Us', href: '#about' },
    { label: 'Sectors', href: '#industries' },
    { label: 'Quality', href: '#quality' },
    { label: 'Team', href: '#about' },
  ],
  contact: 'Contact',
  contactLabel: 'Contact',
  schedule: 'Mon–Fri: 08h–18h',
  rights: 'All rights reserved.',
  devBy: 'Developed by',
};

export default function Footer() {
  const { lang } = useLang();
  const t = lang === 'PT' ? contentPT : contentEN;

  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#0B1A35] text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img
              src="https://public.readdy.ai/ai/img_res/d2adaf2b-9aa5-49c5-bdf3-902a8edfe9b3.png"
              alt="PAMIR"
              className="h-14 w-auto object-contain mb-5 drop-shadow-lg brightness-0 invert"
            />
            <p className="text-white/60 text-sm leading-relaxed mb-6">{t.tagline}</p>
            <div className="flex gap-3">
              <a
                href="https://#"
                className="w-9 h-9 flex items-center justify-center bg-white/10 hover:bg-[#F97316] rounded-lg transition-colors duration-200 cursor-pointer"
                aria-label="LinkedIn"
              >
                <i className="ri-linkedin-box-fill text-base"></i>
              </a>
              <a
                href="https://#"
                className="w-9 h-9 flex items-center justify-center bg-white/10 hover:bg-[#F97316] rounded-lg transition-colors duration-200 cursor-pointer"
                aria-label="Facebook"
              >
                <i className="ri-facebook-box-fill text-base"></i>
              </a>
              <a
                href="https://wa.me/244932527739"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center bg-white/10 hover:bg-[#F97316] rounded-lg transition-colors duration-200 cursor-pointer"
                aria-label="WhatsApp"
              >
                <i className="ri-whatsapp-line text-base"></i>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-[#F97316] text-xs font-bold uppercase tracking-widest mb-5">
              {t.services}
            </h4>
            <ul className="flex flex-col gap-3">
              {t.serviceItems.map((item) => (
                <li key={item}>
                  <button
                    onClick={() => handleNav('#services')}
                    className="text-white/60 hover:text-[#F97316] text-sm transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {item}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-[#F97316] text-xs font-bold uppercase tracking-widest mb-5">
              {t.company}
            </h4>
            <ul className="flex flex-col gap-3">
              {t.companyItems.map((item) => (
                <li key={item.label}>
                  <button
                    onClick={() => handleNav(item.href)}
                    className="text-white/60 hover:text-[#F97316] text-sm transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
              <li>
                <a
                  href="mailto:geral@pamir.ao"
                  className="text-white/60 hover:text-[#F97316] text-sm transition-colors cursor-pointer whitespace-nowrap"
                >
                  {t.contactLabel}
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-[#F97316] text-xs font-bold uppercase tracking-widest mb-5">
              {t.contact}
            </h4>
            <ul className="flex flex-col gap-4">
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-[#F97316] text-base"></i>
                </div>
                <span className="text-white/60 text-sm">(+244)&nbsp;931 265 370 · 928142960</span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-[#F97316] text-base"></i>
                </div>
                <span className="text-white/60 text-sm">geral@pamir.ao</span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-[#F97316] text-base"></i>
                </div>
                <span className="text-white/60 text-sm">Bairro São Paulo, Prédio dos Cubanos, Luanda</span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-[#F97316] text-base"></i>
                </div>
                <span className="text-white/60 text-sm">{t.schedule}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-xs">
            &copy; {new Date().getFullYear()} PAMIR. {t.rights}
          </p>
          <a
            href="https://sysadmin.it.ao"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white/50 hover:text-[#F97316] text-xs transition-colors cursor-pointer whitespace-nowrap"
          >
            {t.devBy} <strong className="font-bold text-white/70">SYSADMIN-T.I, LDA.</strong>
          </a>
        </div>
      </div>
    </footer>
  );
}
